const FinBankCreditScoreResultI18n = {
  topbar: {
    contractScore: 'Hire Sankhya Score',
    updateQuery: 'Update Query',
    downloadReport: 'Download Report',
    downloadReportLoading: 'Generating report...',
    downloadReportError: 'We could not generate the report. Please try again or contact support.',
    consultationHistory: 'Consultation history',
  },
  consultationHistory: {
    title: 'Consultation history',
    subtitle: 'Last 10 consultations',
    scoreLabel: 'Score: {{value}}',
    loadMore: 'Load more consultations',
    alertsUnavailable: 'Alerts and recommendations available only for the current consultation.',
    indicatorsUnavailable: 'Operational indicators history is not available for this consultation.',
  },
  unavailable: {
    badge: 'Unavailable',
  },
  panel: {
    creditScore: 'Credit Score',
    scoreUnavailableSubtitle: 'Information unavailable',
    riskAnalysis: 'Business risk analysis',
    creditLimit: 'Credit limit',
    creditLimitForPj: 'Credit limit for legal entities',
    creditLimitForPf: 'Credit limit for individuals',
    creditLimitSubtitle: 'Suggested and available',
    creditLimitSubtitlePf: 'Suggested',
    scoreEvolution: 'Score evolution (Up to last 10 queries)',
    appointmentsSummary: 'Appointments summary',
    lastUpdatedAt: 'Last updated: {{date}}',
  },
  alerts: {
    sectionTitle: 'Alerts and recommendations',
    latePayment: 'The last 3 invoices were paid late.',
    inactiveCustomer: 'Customer has not made purchases in the last 60 days.',
    increasingDelinquency: 'Delinquency increased in the last 2 closed months.',
    creditLimitNearMax: 'Credit limit near maximum. {{percent}}% of approved limit in use.',
  },
  gauge: {
    scoreAriaLabel: 'Score {{score}} out of {{scoreMax}}',
    of: 'of {{scoreMax}}',
    probabilityTitle: 'Default probability',
    riskLabel: {
      LOW: 'Low risk',
      MEDIUM: 'Medium risk',
      HIGH: 'High risk',
    },
    scoreUnavailableTitle: 'Score unavailable',
    scoreUnavailableDescription: 'This query is under judicial restriction, so the score data cannot be displayed at this time.',
  },
  risk: {
    cautionLabel: 'Recommended caution level for this negotiation',
    evaluateWithCaution: 'Evaluate with caution.',
    suggestionTooltip: 'This suggestion does not replace an analysis of all information; the decision and responsibility remain with the creditor.',
  },
  riskAnalysis: {
    label: {
      PF: {
        LOW: 'Approve',
        HIGH: 'Reject',
      },
      PJ: {
        LOW: 'Recommended profile',
        MEDIUM: 'Average profile',
        HIGH: 'Risky profile',
      },
    },
    description: {
      PF: {
        LOW: 'Shows low delinquency, good payment behavior, with no protests, civil lawsuits, or debts.',
        HIGH: 'Profile with low score, high probability of default, or open debts. Requires detailed analysis.',
      },
      PJ: {
        LOW: 'Companies with this profile have a low history of delinquency and good payment capacity.',
        MEDIUM: 'Companies with this profile may have open debts and reduced score, but currently have good payment capacity.',
        HIGH: 'Companies with this profile have a high risk of default and require caution in negotiation.',
      },
    },
    personType: {
      PF: 'Individual',
      PJ: 'Legal entity',
    },
    unavailable: {
      label: 'Unavailable',
      description: 'Business risk analysis not available.',
    },
  },
  probability: {
    label: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
    },
    description: {
      PF: 'It is likely that {{value}}% of people with the same behavior will pay their bills in the next 6 months.',
      PJ: 'Out of every 1000 companies classified in this score class, an average of {{value}} is likely to present debts in the market in the next 12 months.',
    },
    unavailable: {
      noRelevantInfo: 'No relevant information available to calculate the score.',
      notClassified: 'Company not classified, as the model does not apply to this company profile.',
      scoreUnavailable: 'Score unavailable.',
    },
  },
  limit: {
    suggestedTotal: 'Suggested total',
    suggestedTotalPf: 'Maximum amount per installment',
    usagePercent: '{{percent}}% used',
    usageAriaLabel: 'Limit used {{percent}}%',
    available: 'Available',
    used: 'Used',
    tooltips: {
      suggestedTotal: 'Credit value suggested based on analysis of market data (bureaus).',
      available: 'Amount still available for use, considering the suggested total minus the amount already used.',
      used: 'Sum of amounts already committed, considering open "revenue" titles linked to the partner in the ERP.',
    },
  },
  metrics: {
    tooltips: {
      averageTicket: 'Average value of sales made by the partner in the ERP',
      defaultRate: 'Percentage of overdue amounts compared to total receivables from the partner in the ERP',
      averageSalesPerMonth: 'Average number of monthly sales for the partner based on its ERP history.',
      averageReceiptTerm: 'Average collection time for the partner in the ERP',
    },
  },
  chart: {
    seriesName: 'Score',
    emptyMessage: 'Insufficient history to plot score evolution.',
  },
  metricCards: {
    averageTicket: {
      label: 'Average ticket',
      labelPF: 'Average installment amount',
      helper: 'Last 6 months',
    },
    delinquencyRate: {
      label: 'Delinquency',
      helper: 'Last 6 months',
    },
    averageMonthlySales: {
      label: 'Average monthly sales',
      helper: 'Last 6 months',
    },
    averageDaysToCollect: {
      label: 'Average days to collect',
      helper: 'Last 6 months',
      value: '{{days}} days',
    },
  },
  appointments: {
    status: {
      healthy: 'Healthy',
      attention: 'Attention',
    },
    debts: {
      title: 'Debts / Restrictions',
      latestDateLabel: 'Date of most recent debt',
      totalCountLabel: 'Total debts',
      totalValueLabel: 'Total debt amount',
      emptyMessage: 'No debts found',
      detail: {
        title: 'Debts and Restrictions',
        fields: {
          creditor: 'Creditor name',
          amount: 'Amount',
          date: 'Date',
          contract: 'Contract number',
          location: 'Location',
          classification: 'Classification type',
        },
      },
    },
    civilActions: {
      title: 'Civil Lawsuits',
      latestDateLabel: 'Date of most recent action',
      totalCountLabel: 'Total actions',
      emptyMessage: 'No actions found',
      detail: {
        title: 'Civil Lawsuits',
        subtitle: 'Up to {{count}} most recent',
        fields: {
          plaintiff: 'Plaintiff',
          amount: 'Amount',
          action: 'Action',
          date: 'Date',
          case: 'Case',
          location: 'Location',
        },
      },
    },
    protests: {
      title: 'Protests',
      latestDateLabel: 'Date of most recent protest',
      totalCountLabel: 'Total protests',
      totalValueLabel: 'Total protest amount',
      emptyMessage: 'No protests found',
      detail: {
        title: 'Protests',
        subtitle: 'Up to {{count}} most recent',
        fields: {
          date: 'Date',
          amount: 'Amount',
          notary: 'Notary office',
          city: 'City',
          state: 'State',
        },
      },
    },
  },
  details: {
    pageIndicator: '{{current}} of {{total}}',
    emptyMessage: 'No records found',
    restrictionMessage: 'This query is under judicial restriction, so the data cannot be displayed at this time.',
  },
};

export default FinBankCreditScoreResultI18n;
